export const GLOBAL_EVENTS = {
  OPEN_TRANSFER_MODAL: "open-transfer-modal",
  OPEN_NEW_ADDRESS_MODAL: "open-new-address-modal",
  OPEN_EARN_DEPOSIT_MODAL: "open-earn-deposit-modal",
  SET_PAGE_TITLE: "set-page-title",
  WEBSOCKET_CONNECTED: "websocket-connected",
  OPEN_NOTIFICATIONS: "open-notifications",
  UPDATE_CANDLE: "update-candle",
};
